/**
 * PageLoader — universal branded loading screen.
 *
 * Usage:
 *   <PageLoader />                        // centré, message par défaut
 *   <PageLoader message="Chargement…" />  // message personnalisé
 *   <PageLoader fullscreen />             // occupe tout l'écran (ex: auth check)
 */

import { PRODUCT_NAME } from '../config/branding';

interface PageLoaderProps {
    message?: string;
    fullscreen?: boolean;
}

export default function PageLoader({ message, fullscreen = false }: PageLoaderProps) {
    const wrapper = fullscreen
        ? 'fixed inset-0 z-50 bg-[#F9FAFB]'
        : 'w-full min-h-[320px]';

    return (
        <div className={`${wrapper} flex flex-col items-center justify-center gap-6`}>
            {/* Logo + nom */}
            <div className="flex items-center gap-3">
                <img
                    src="/logo.png"
                    alt={PRODUCT_NAME}
                    className="w-11 h-11 rounded-xl"
                    onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                />
                <span className="text-2xl font-bold tracking-tight text-gray-900">
                    {PRODUCT_NAME}
                </span>
            </div>

            {/* Barre shimmer */}
            <div className="w-48 h-[3px] bg-gray-200 rounded-full overflow-hidden">
                <div
                    className="h-full w-2/5 bg-[#FF6B35] rounded-full"
                    style={{ animation: 'kf-shimmer 1.2s ease-in-out infinite' }}
                />
            </div>

            {/* Message */}
            {message && (
                <p className="text-xs text-gray-400 uppercase tracking-widest">{message}</p>
            )}
        </div>
    );
}
